module.exports = __webpack_public_path__ + "static/media/11.ccf6e74b.mp3";